module.exports = __webpack_public_path__ + "img/arrow-down.5dc739c8.svg";